import { messages } from 'i18n';
import SetEndUserPage from 'broker/pages/SetEndUserPage';

export default function BackOfficePage() {
  return (
    <SetEndUserPage
      title={messages.backOfficePage.title}
      selectPlaceholder={messages.backOfficePage.title}
      signOutText={messages.backOfficePage.signOutText}
      setUserText={messages.backOfficePage.setUserText}
    />
  );
}
